import { mapGetters } from 'vuex';
import cartStockChecker from '~/mixins/cart-stock-checker';

export default {
    mixins: [cartStockChecker],
    data() {
        return {
            tabId: null,
        };
    },
    computed: {
        ...mapGetters({
            cart: 'cart/getCart',
        }),
    },
    methods: {
        subscribeForProductsCartUpdate() {
            if ('BroadcastChannel' in window) {
                const bc = new BroadcastChannel('product_cart');
                console.log('chanel1');
                bc.onmessage = async event => {
                    const targetTabId = event.data.tabId;
                    const cartData = event.data.cart;

                    if (targetTabId !== this.tabId && cartData) {
                        await this.stockCheckHandler(JSON.parse(JSON.stringify(cartData)));
                    }
                };
            }
        },
        bcCartUpdatePostMessage() {
            if ('BroadcastChannel' in window) {
                const bc = new BroadcastChannel('product_cart');

                bc.postMessage({
                    cart: this.cart,
                    tabId: this.tabId,
                });

                bc.close();
            }
        },
        createTabId() {
            this.tabId = Date.now();
        },
    },
    mounted() {
        this.createTabId();
    },
};
